import { render, staticRenderFns } from "./base-table-downloads.vue?vue&type=template&id=35248105&scoped=true"
import script from "./base-table-downloads.vue?vue&type=script&lang=ts"
export * from "./base-table-downloads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35248105",
  null
  
)

export default component.exports